export var CalendarViewKind;
(function (CalendarViewKind) {
    CalendarViewKind[CalendarViewKind["day"] = 0] = "day";
    CalendarViewKind[CalendarViewKind["month"] = 1] = "month";
    CalendarViewKind[CalendarViewKind["year"] = 2] = "year";
})(CalendarViewKind || (CalendarViewKind = {}));
export var CalendarNavigationAction;
(function (CalendarNavigationAction) {
    CalendarNavigationAction[CalendarNavigationAction["PrevCell"] = 0] = "PrevCell";
    CalendarNavigationAction[CalendarNavigationAction["NextCell"] = 1] = "NextCell";
    CalendarNavigationAction[CalendarNavigationAction["UpperCell"] = 2] = "UpperCell";
    CalendarNavigationAction[CalendarNavigationAction["LowerCell"] = 3] = "LowerCell";
    CalendarNavigationAction[CalendarNavigationAction["FirstCell"] = 4] = "FirstCell";
    CalendarNavigationAction[CalendarNavigationAction["LastCell"] = 5] = "LastCell";
    CalendarNavigationAction[CalendarNavigationAction["StartCell"] = 6] = "StartCell";
    CalendarNavigationAction[CalendarNavigationAction["EndCell"] = 7] = "EndCell";
    CalendarNavigationAction[CalendarNavigationAction["PrevView"] = 8] = "PrevView";
    CalendarNavigationAction[CalendarNavigationAction["NextView"] = 9] = "NextView";
    CalendarNavigationAction[CalendarNavigationAction["PrevExtraView"] = 10] = "PrevExtraView";
    CalendarNavigationAction[CalendarNavigationAction["NextExtraView"] = 11] = "NextExtraView";
})(CalendarNavigationAction || (CalendarNavigationAction = {}));
